// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.branch-dictionary-modal {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 90vh;
}
.branch-dictionary-modal .modal-search-header {
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  background: #f9f9f9;
}
.branch-dictionary-modal .modal-search-header .search-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.branch-dictionary-modal .modal-search-header .search-input-container input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.branch-dictionary-modal .modal-search-header .search-input-container .search-btn {
  padding: 8px 12px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.branch-dictionary-modal .modal-search-header .search-input-container .search-btn:hover {
  background: #0056b3;
}
.branch-dictionary-modal .modal-search-header .search-input-container .clear-button {
  padding: 8px 12px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.branch-dictionary-modal .modal-search-header .search-input-container .clear-button:hover {
  background: #545b62;
}
.branch-dictionary-modal .select-col {
  width: 60px;
  text-align: center;
}
.branch-dictionary-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: #f5f5f5;
}
.branch-dictionary-modal .modal-header h2 {
  margin: 0;
  font-size: 1.5em;
  color: #333;
}
.branch-dictionary-modal .modal-header .close-button {
  background: none;
  border: none;
  font-size: 1.5em;
  color: #666;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
}
.branch-dictionary-modal .modal-header .close-button:hover {
  background: #e0e0e0;
  color: #333;
}
.branch-dictionary-modal .modal-content {
  flex: 1;
  overflow: auto;
  padding: 16px;
  background: white;
}
.branch-dictionary-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  background: #f5f5f5;
}
.branch-dictionary-modal .modal-footer .cancel-btn {
  padding: 8px 16px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  color: #666;
}
.branch-dictionary-modal .modal-footer .cancel-btn:hover {
  background: #f0f0f0;
}
.branch-dictionary-modal .modal-footer .confirm-btn {
  padding: 8px 16px;
  background: #007bff;
  border: 1px solid #007bff;
  border-radius: 4px;
  cursor: pointer;
  color: white;
}
.branch-dictionary-modal .modal-footer .confirm-btn:hover:not(:disabled) {
  background: #0056b3;
}
.branch-dictionary-modal .modal-footer .confirm-btn:disabled {
  background: #ccc;
  border-color: #ccc;
  cursor: not-allowed;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
